export const version = "ethers/5.8.0";
//# sourceMappingURL=_version.js.map